var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentPaymentIconH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 24,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAAXNSR0IB2cksfwAAAYlQTFRFAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYoIbrrAAAAIN0Uk5TABiX8m4LATzmxTYKEFb/ez8epKHclQcCcMnP3jD82tPvwOvKxooM9F9BfPNqQFDBtU/jbZSqPe6/zScIh3Z3maADNH0gdVUNrygphu3Q5K4TESqWLAW31LByx4USJOrIMQQbDo4UZYPReItK9mIiRSZDc+BgiJwaqTm58NXovdbf9dgTqbikAAABTklEQVR4nGNkAAJGEPgNYjGwgZjfQGIMDNwg9k+OP2AJVhDng+ArBkZxEOszHyMjTOIHJ9gARnYFIPGEj5+RkQFi6ktO/r8sQDETxtMMZiAVx8AS1ox//7EdZrBjZLRnPMDgCBTfwwAB3FaMjDsZJNQZ7TkZGVAA438gwfSF0Z4XTQIi+5HRXuAXFgmQDqAdmABkB1TC8+8uLBIBwGDgXhtyCywocuUVTCJ0fRAj48r/kTA/LoHriAV6ZAFD4mqwROh8JDuSFv/GZXnikt9YJMQZfG6rzUl9AhbcIfYSbrkg4znj+T8zd9mAQ+v3bJiEoxbjJ/6Zv/IY94EknC/uR9hReHMPSsggWY4RJEwC74AMx/0MbAxIeorOMuayzfyi5vdkJUsB47OtKo9tlRgZT+wXT37LKJYC9PV5o3PqPLOTF1upzZO8VDHX65lJPQDCv2dIU8akhgAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1 copy 2",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentPaymentIconH);
export default __webpack_public_path__ + "static/media/student-payment-icon-h.133b384b0736326fcdb55e053428a09e.svg";
export { ForwardRef as ReactComponent };